import { Navigate } from 'react-router-dom';
import { Button, Paper, Stack, Typography } from '@mui/material';
import { useAuth } from './AuthContext';
import { homePathFor } from '../components/navConfig';

/** Root route: sends an authenticated user to the first area their roles allow. */
export function HomeRedirect(): JSX.Element {
  const { user, logout } = useAuth();
  if (!user) return <Navigate to="/login" replace />;

  const home = homePathFor(user.roles);
  if (home) return <Navigate to={home} replace />;

  // No usable role: every guard would bounce back here, so stop instead of looping.
  return (
    <Stack sx={{ minHeight: '100vh', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Paper sx={{ p: 4, maxWidth: 420 }} elevation={2}>
        <Stack spacing={2}>
          <Typography variant="h5">No access</Typography>
          <Typography color="text.secondary">
            Your account has no role that gives access to this organisation. Contact an
            administrator if you think this is a mistake.
          </Typography>
          <Button variant="outlined" onClick={() => void logout()}>
            Sign out
          </Button>
        </Stack>
      </Paper>
    </Stack>
  );
}
